export const maxCommentSize = 1024;